import { render } from "./FinancaProductHistoryDrawer.vue?vue&type=template&id=61fe7a95"
import script from "./FinancaProductHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./FinancaProductHistoryDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__